import type { BatchPhase, Trigger } from '@autopilot/contracts';
import { Bot, UserRound } from 'lucide-react';
import Chip from '@mui/material/Chip';
import { PHASE_LABEL, TRIGGER_LABEL } from '../lib/labels';
import { navy, red } from '../theme/theme';
import { ToneBadge } from './StatusBadge';

export function ModeBadge({ trigger }: { trigger: Trigger }) {
  const auto = trigger === 'SCHEDULED';
  return (
    <Chip
      size="small"
      variant="outlined"
      icon={auto ? <Bot size={14} aria-hidden /> : <UserRound size={14} aria-hidden />}
      label={TRIGGER_LABEL[trigger]}
      sx={{
        fontWeight: 600,
        color: auto ? navy[600] : red[700],
        borderColor: auto ? navy[100] : red[200],
        backgroundColor: auto ? navy[50] : red[50],
        '& .MuiChip-icon': { color: 'inherit' },
      }}
    />
  );
}

export function PhaseBadge({ phase }: { phase: BatchPhase }) {
  const p = PHASE_LABEL[phase] ?? { label: phase, tone: 'neutral' as const };
  const running = phase === 'SELECTING' || phase === 'PREHEATING' || phase === 'EXECUTING';
  return <ToneBadge tone={p.tone} label={p.label} spinning={running} />;
}
